export default {
  'notification.title': 'Notifications',
  'notification.empty': 'No notifications',
  'notification.empty.unread': 'No unread notifications',
  'notification.markAllRead': 'Mark all as read',
  'notification.markAllRead.success': 'All marked as read',
  'notification.markAllRead.failed': 'Failed to mark, please retry',
  'notification.markRead': 'Mark as read',
  'notification.markRead.success': 'Marked as read',
  'notification.markRead.failed': 'Failed to mark, please retry',
  'notification.tab.all': 'All',
  'notification.type.system': 'System',
  'notification.type.transaction': 'Transaction',
  'notification.type.marketing': 'Marketing',
  'notification.time.now': 'Just now',
  'notification.time.minutes': '{count} minutes ago',
  'notification.time.hours': '{count} hours ago',
  'notification.time.days': '{count} days ago',
  'notification.filter.label': 'Filter',
  'notification.filter.all': 'All',
  'notification.filter.unreadOnly': 'Unread',
};
